import { ReactNode, createContext } from "react";
import useRelatorioVenda, { RelatorioVendaType, CreateRelatorioVendaType, EditRelatorioVendaType, AlunoVendedorType, EditRelacaoRelatorioVendaType, CreateRelacaoRelatorioVendaType, AtualizarStatusRelatorioVendaRequest, VendaNaoRealizadaType, CreateVendaNaoRealizadaType, UpdateVendaNaoRealizadaType, VendaNaoRealizadaPagedResponse, VendasNaoRealizadasEmpresaFilters } from "./hooks/useRelatorioVenda";

interface RelatorioVendaContextProviderProps {
    children: ReactNode;
}

export interface RelatorioVendaContextData {
    createRelatorioVenda: (createRelatorioVendaData: CreateRelatorioVendaType) => Promise<CreateRelatorioVendaType | null>;
    getRelatorioVendaPaged: (
        pageNumber: number,
        RelatorioId?: number,
        EmpresaId?: number,
        ContratoId?: number,
        pageSize?: number,
        Status?: number,
        InitialDate?: string,
        FinalDate?: string,
    ) => Promise<RelatorioVendaType[] | null>;
    updateRelatorioVenda: (editRelatorioVendaData: EditRelatorioVendaType) => Promise<EditRelatorioVendaType | null>;
    deleteRelatorioVenda: (relatorioVendaId: number) => Promise<RelatorioVendaType | null>;
    setRelatorioVenda: any;
    relatorioVenda: RelatorioVendaType;
    listRelatorioVenda: RelatorioVendaType[];
    initialListRelatorioVenda: RelatorioVendaType[];
    setListRelatorioVenda: (relatorioVenda: RelatorioVendaType[]) => void;
    setRelatorioVendaPageCount: (count: number) => void;
    relatorioVendaPageCount: number;
    getAlunosVendedoresByRelatorioId: (relatorioVendaId: number) => Promise<AlunoVendedorType[] | null>;
    getAlunosVendedoresPaged: (
        relatorioVendaId: number,
        pageNumber: number,
        pageSize?: number,
        name?: string,
        alunoId?: number,
    ) => Promise<AlunoVendedorType[] | null>;
    adicionarRelacoesAoRelatorio: (relatorioVendaId: number, relacoes: CreateRelacaoRelatorioVendaType[]) => Promise<boolean>;
    updateRelacoesRelatorioVenda: (editRelacaoRelatorioVendaData: EditRelacaoRelatorioVendaType) => Promise<EditRelacaoRelatorioVendaType | null>;
    removerRelacaoRelatorioVenda: (relatorioVendaId: number, alunoId: number, vendedorId: number) => Promise<boolean>;
    relacaoAlunosVendedores: AlunoVendedorType;
    listRelacaoAlunosVendedores: AlunoVendedorType[];
    listVendasNaoRealizadas: VendaNaoRealizadaType[];
    listVendasNaoRealizadasEmpresa: VendaNaoRealizadaType[];
    vendasNaoRealizadasEmpresaPageCount: number;
    getVendasNaoRealizadasByEmpresa: (empresaId: number, page: number, pageSize: number, filters?: VendasNaoRealizadasEmpresaFilters) => Promise<VendaNaoRealizadaPagedResponse | null>;
    updateVendaNaoRealizada: (id: number, request: UpdateVendaNaoRealizadaType) => Promise<boolean>;
    initialListRelacaoAlunosVendedores: AlunoVendedorType[];
    relacaoAlunosVendedoresPageCount: number;
    downloadRelatorioVendaPdf: (
        relatorioId: number,
        statusFilter?: number,
        vendedorId?: number
    ) => Promise<void>;
    downloadRelatorioReduzidoVendaPdf: (
        relatorioId: number,
        statusFilter?: number,
        vendedorId?: number
    ) => Promise<void>;
    atualizarStatusLote: (relatorioVendaId: number, request: AtualizarStatusRelatorioVendaRequest) => Promise<boolean>;
    getVendasNaoRealizadas: (relatorioVendaId: number) => Promise<VendaNaoRealizadaType[] | null>;
    createVendaNaoRealizada: (request: CreateVendaNaoRealizadaType) => Promise<VendaNaoRealizadaType | null>;
    validarAlunoEmOutroRelatorioEmRota: (alunoId: number) => Promise<boolean>;
    validarVendedorComContratosAbertos: (vendedorId: number) => Promise<boolean>;
    validarAlunoPertenceAoContrato: (alunoId: number, contratoId: number) => Promise<boolean>;
    handleGetRelatorioByEmpresaId: (empresaId: number) => Promise<RelatorioVendaType[] | null>;
    downloadRelatorioVendasAtivasPdf: (empresaId: number, vendedorId?: number, statusRelacao?: number, initialDate?: string, finalDate?: string) => Promise<void>;
    downloadRelatorioMultiplosPdf: (empresaId: number, relatorioIds: number[]) => Promise<void>;
}

const initialState: RelatorioVendaContextData = {
    createRelatorioVenda: async () => null,
    getRelatorioVendaPaged: async () => null,
    updateRelatorioVenda: async () => null,
    deleteRelatorioVenda: async () => null,
    setRelatorioVenda: () => { },
    relatorioVenda: {
        id: 0,
        date: "",
        status: 0,
        checked: false,
        dateChecked: "",
        empresaId: 0,
        contratoId: 0,
    },
    listRelatorioVenda: [],
    initialListRelatorioVenda: [],
    setListRelatorioVenda: () => { },
    setRelatorioVendaPageCount: () => { },
    relatorioVendaPageCount: 0,
    getAlunosVendedoresByRelatorioId: async () => null,
    getAlunosVendedoresPaged: async () => null,
    adicionarRelacoesAoRelatorio: async () => false,
    updateRelacoesRelatorioVenda: async () => null,
    removerRelacaoRelatorioVenda: async () => false,
    relacaoAlunosVendedores: {
        id: 0,
        alunoId: 0,
        alunoNome: "",
        vendedorId: 0,
        vendedorNome: "",
        cursoNome: "",
        numberPhotos: 0,
        status: 0,
    },
    listRelacaoAlunosVendedores: [],
    listVendasNaoRealizadas: [],
    initialListRelacaoAlunosVendedores: [],
    relacaoAlunosVendedoresPageCount: 0,
    downloadRelatorioVendaPdf: async (
        relatorioId: number,
        statusFilter?: number,
        vendedorId?: number
    ) => { },
    downloadRelatorioReduzidoVendaPdf: async (
        relatorioId: number,
        statusFilter?: number,
        vendedorId?: number
    ) => { },
    atualizarStatusLote: async () => false,
    getVendasNaoRealizadas: async () => null,
    getVendasNaoRealizadasByEmpresa: async () => null,
    createVendaNaoRealizada: async () => null,
    updateVendaNaoRealizada: async () => false,
    listVendasNaoRealizadasEmpresa: [],
    vendasNaoRealizadasEmpresaPageCount: 0,
    validarAlunoEmOutroRelatorioEmRota: async () => false,
    validarVendedorComContratosAbertos: async () => false,
    validarAlunoPertenceAoContrato: async () => false,
    handleGetRelatorioByEmpresaId: async () => null,
    downloadRelatorioVendasAtivasPdf: async () => { },
    downloadRelatorioMultiplosPdf: async () => { },
};

export const RelatorioVendaContext =
    createContext<RelatorioVendaContextData>(initialState);

export default function RelatorioVendaContextProvider({
    children,
}: RelatorioVendaContextProviderProps) {
    const {
        createRelatorioVenda,
        getRelatorioVendaPaged,
        updateRelatorioVenda,
        deleteRelatorioVenda,
        setRelatorioVenda,
        relatorioVenda,
        listRelatorioVenda,
        initialListRelatorioVenda,
        setListRelatorioVenda,
        relatorioVendaPageCount,
        setRelatorioVendaPageCount,
        getAlunosVendedoresByRelatorioId,
        getAlunosVendedoresPaged,
        adicionarRelacoesAoRelatorio,
        updateRelacoesRelatorioVenda,
        removerRelacaoRelatorioVenda,
        relacaoAlunosVendedores,
        listRelacaoAlunosVendedores,
        listVendasNaoRealizadas,
        listVendasNaoRealizadasEmpresa,
        vendasNaoRealizadasEmpresaPageCount,
        getVendasNaoRealizadasByEmpresa,
        updateVendaNaoRealizada,
        initialListRelacaoAlunosVendedores,
        relacaoAlunosVendedoresPageCount,
        downloadRelatorioVendaPdf,
        downloadRelatorioReduzidoVendaPdf,
        atualizarStatusLote,
        getVendasNaoRealizadas,
        createVendaNaoRealizada,
        validarAlunoEmOutroRelatorioEmRota,
        validarVendedorComContratosAbertos,
        validarAlunoPertenceAoContrato,
        handleGetRelatorioByEmpresaId,
        downloadRelatorioVendasAtivasPdf,
        downloadRelatorioMultiplosPdf,
    } = useRelatorioVenda();

    return (
        <RelatorioVendaContext.Provider
            value={{
                createRelatorioVenda,
                getRelatorioVendaPaged,
                getAlunosVendedoresPaged,
                updateRelatorioVenda,
                deleteRelatorioVenda,
                setRelatorioVenda,
                relatorioVenda,
                listRelatorioVenda,
                initialListRelatorioVenda,
                setListRelatorioVenda,
                setRelatorioVendaPageCount,
                relatorioVendaPageCount,
                getAlunosVendedoresByRelatorioId,
                adicionarRelacoesAoRelatorio,
                updateRelacoesRelatorioVenda,
                removerRelacaoRelatorioVenda,
                relacaoAlunosVendedores,
                listRelacaoAlunosVendedores,
                listVendasNaoRealizadas,
                listVendasNaoRealizadasEmpresa,
                vendasNaoRealizadasEmpresaPageCount,
                getVendasNaoRealizadasByEmpresa,
                updateVendaNaoRealizada,
                initialListRelacaoAlunosVendedores,
                relacaoAlunosVendedoresPageCount,
                downloadRelatorioVendaPdf,
                downloadRelatorioReduzidoVendaPdf,
                atualizarStatusLote,
                getVendasNaoRealizadas,
                createVendaNaoRealizada,
                validarAlunoEmOutroRelatorioEmRota,
                validarVendedorComContratosAbertos,
                validarAlunoPertenceAoContrato,
                handleGetRelatorioByEmpresaId,
                downloadRelatorioVendasAtivasPdf,
                downloadRelatorioMultiplosPdf,
            }}
        >
            {children}
        </RelatorioVendaContext.Provider>
    );
}
